import { Trans } from 'react-i18next';
import './NoOtherSupplier.less';

export const NoOtherSupplier = ({
  listLength,
  tip,
}: {
  listLength: number;
  tip?: React.ReactElement;
}) => {
  return (
    <div className="noOtherSupplier-tip" hidden={listLength >= 5}>
      {tip ? tip : <Trans i18nKey="jobConfig.noOtherSupplier"></Trans>}
    </div>
  );
};
